module.exports = __webpack_public_path__ + "static/media/hero-image.bdbb9fb2.jpg";